// extracted by mini-css-extract-plugin
export var filterIncDec = "_3p-0";
export var leftBorder = "_3p-1";
export var rightBorder = "_3p-2";
export var stringInput = "_3p-3";